module.exports = __webpack_public_path__ + "static/media/smellycheese.36ac9198.png";